export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./audioResource.vue?vue&type=template&id=4f026653&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/resource/audioResource.vue?vue&type=template&id=4f026653&scoped=true&
// module id = null
// module chunks = 